import React, { Component, useCallback, useMemo, useState } from "react";
import {
  ButtonBase,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import styles from "./Style.module.css";
import Constants from "../../../../../../../config/constants";
import useAddEmployeeTable from "./AddEmployeeTable.hook";
import Datatables from "../../../../../../../components/Datatables/datatables";
import FilterComponent from "../../../../../../../components/Filter/Filter.component";
import { Autocomplete } from "@material-ui/lab";
import SnackbarUtils from "../../../../../../../libs/SnackbarUtils";

const fieldLabels = {
  GRADES: "Grade",
  DESIGNATIONS: "Designation",
  ZONES: "Zone",
  STATES: "State",
  HQS: "HQ",
  LOCATIONS: "Location",
  DEPARTMENTS:"Department"
};
const AddEmployeeTable = ({
  handleClose,
  handleSubmit,
  editEmployee,
  groupId,
  isLoading,
}) => {
  const {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    handleRowSelection,
    handleEdit,
    handleFilterDataChange,
    handleSearchValueChange,
    handleViewDetails,
    isCalling,
    handleCheckbox,
    selected,
    data,
    currentData,
    currentPage,
    isFetching,
    changeTextData,
    form,
    listData,
    isShowFilter,
    selectAllEmployee,
  } = useAddEmployeeTable({ handleClose, editEmployee });

  const renderFirstCell = useCallback(
    (data) => {
      const selectedIndex = selected.findIndex((sel) => sel.id === data.id);
      return (
        <div className={styles.flex}>
          <Checkbox
            disabled={false}
            onChange={() => handleCheckbox(data)}
            checked={selectedIndex >= 0}
            value="secondary"
            className={styles.checkBoxClass}
          />
          <div>
            {data?.name}
            <br />
            {data?.emp_code}
          </div>
        </div>
      );
    },
    [handleCheckbox, selected]
  );

  const tableStructure = useMemo(() => {
    return [
      {
        key: "check",
        label: (
          <div className={styles.flex}>
            <div className={styles.selectallCheckbox}>
              {isShowFilter && (
                <Checkbox
                  onChange={(e) => {
                    selectAllEmployee(e);
                  }}
                  checked={
                    data?.length > 0 && data?.length === selected?.length
                  }
                  value="secondary"
                  className={styles.checkBoxClass}
                />
              )}
            </div>

            <div>Employee</div>
          </div>
        ),
        sortable: false,
        render: (value, all) => <div>{renderFirstCell(all)}</div>,
      },
      // {
      //   key: "name",
      //   label: "Employee",
      //   sortable: false,
      //   render: (temp, all) => (
      //     <div>
      //       {all?.name}
      //       <br />
      //       {all?.code}
      //     </div>
      //   ),
      // },

      {
        key: "designation",
        label: "DESIGNATION",
        sortable: false,
        render: (temp, all) => <div>{all?.designation?.name}</div>,
      },

      {
        key: "location",
        label: "LOCATION",
        sortable: false,
        render: (temp, all) => <div>{all?.location?.name}</div>,
      },
      {
        key: "department",
        label: "DEPARTMENT",
        sortable: false,
        render: (temp, all) => <div>{all?.department?.name}</div>,
      },
    ];
  }, [renderFirstCell, handleViewDetails, handleEdit, isCalling]);

  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSelection: handleRowSelection,
      onRowSizeChange: handleRowSize,
    };

    const datatable = {
      ...Constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: currentData,
      count: data.length,
      page: currentPage - 1,
      rowsPerPage: 10,
      // allRowSelected: true,
      // showSelection: true,
    };

    return { datatableFunctions, datatable };
  }, [
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    data,
    currentPage,
    currentData,
  ]); // allData,

  return (
    <div className={styles.sliderWrapper}>
      {isShowFilter && (
        <div style={{ paddingRight: "10px" }}>
          <div className={styles.title}>Filter Members By</div>
          <div className={styles.radioWrapper}>
            <RadioGroup
              aria-label="option"
              name="filtered_by"
              value={form?.filtered_by}
              onChange={(e) => changeTextData(e.target.value, "filtered_by")}
              row
              className={styles.radioWrap}
            >
              <FormControlLabel
                // style={{ marginLeft: "20px" }}
                value="GRADES"
                control={<Radio />}
                label="Grade"
                classes={{ label: styles.radioLabel }}
                // className={styles.radioLabel}
                disabled={groupId ? true : false}
              />
              <FormControlLabel
                value="DESIGNATIONS"
                control={<Radio />}
                label="Designation"
                classes={{ label: styles.radioLabel }}
                disabled={groupId ? true : false}
              />
              <FormControlLabel
                value="ZONES"
                control={<Radio />}
                label="Zones"
                classes={{ label: styles.radioLabel }}
                disabled={groupId ? true : false}
              />{" "}
              <FormControlLabel
                value="STATES"
                control={<Radio />}
                label="State"
                classes={{ label: styles.radioLabel }}
                disabled={groupId ? true : false}
              />
              {/* <FormControlLabel
                value="HQS"
                control={<Radio />}
                label="HQ"
                classes={{ label: styles.radioLabel }}
              />*/}
              <FormControlLabel
                value="LOCATIONS"
                control={<Radio />}
                label="Location"
                classes={{ label: styles.radioLabel }}
                disabled={groupId ? true : false}
              />
               <FormControlLabel
                value="DEPARTMENTS"
                control={<Radio />}
                label="Department"
                classes={{ label: styles.radioLabel }}
                disabled={groupId ? true : false}
              />
            </RadioGroup>
            {form?.filtered_by && (
              <div className={styles.multiWrap}>
                <Autocomplete
                  multiple
                  id="tags-outlined"
                  onChange={(e, value) => {
                    changeTextData(value, "type");
                  }}
                  disabled={groupId ? true : false}
                  value={form?.type}
                  options={listData?.[form?.filtered_by] || []}
                  getOptionLabel={(option) => option.label}
                  defaultValue={form?.type}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label={`Select ${fieldLabels[form?.filtered_by]}`}
                      // error={errorData?.type}
                      sx={{
                        "& .MuiInputBase-root": {
                          padding: "2px",
                        },
                        "& .MuiOutlinedInput-input": {
                          padding: "2px",
                        },
                        "& .MuiInputLabel-root": {
                          top: "-5px",
                        },
                      }}
                    />
                  )}
                />
              </div>
            )}
          </div>
        </div>
      )}

      <div className={styles.sliderWrapperContainer}>
        <div>
          <FilterComponent
            is_progress={isFetching}
            filters={[]}
            handleSearchValueChange={handleSearchValueChange}
            handleFilterDataChange={handleFilterDataChange}
            placeholder={"Search by employee name or code"}
          />
          {isShowFilter && (
            <div className={styles.isMobileCheckbox}>
              <Checkbox
                onChange={(e) => {
                  selectAllEmployee(e);
                }}
                checked={data?.length > 0 && data?.length === selected?.length}
                value="secondary"
                className={styles.checkBoxClass}
              />
              Select All Employee
            </div>
          )}
          <Datatables
            {...tableData.datatable}
            {...tableData.datatableFunctions}
          />
        </div>
        <div className={styles.stickBottom}>
          <div className={styles.RequestShortlistWrapper}>
            <div className={styles.btnWrap}>
              <div className={styles.heading3}>
                {selected?.length}{" "}
                {`${selected?.length > 1 ? "Employees" : "Employee"}`} Selected
              </div>
            </div>
            <div>
              <ButtonBase
                disabled={isLoading}
                onClick={() => {
                  handleSubmit(selected, form, isShowFilter);
                }}
                className={styles.createBtn}
              >
                {isLoading ? (
                  <CircularProgress color="success" size="20px" />
                ) : (
                  `${groupId ? "Update" : "Create"} GROUP`
                )}
              </ButtonBase>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEmployeeTable;
